export default __webpack_public_path__ + "static/media/delete-info.a2fb0064.svg";